import { render, staticRenderFns } from "./index-router-link.vue?vue&type=template&id=8a54b85e&scoped=true&"
import script from "./index-router-link.vue?vue&type=script&lang=js&"
export * from "./index-router-link.vue?vue&type=script&lang=js&"
import style0 from "./index-router-link.vue?vue&type=style&index=0&id=8a54b85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a54b85e",
  null
  
)

export default component.exports